import { render, staticRenderFns } from "./index.vue?vue&type=template&id=244c7f13"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=244c7f13&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244c7f13')) {
      api.createRecord('244c7f13', component.options)
    } else {
      api.reload('244c7f13', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=244c7f13", function () {
      api.rerender('244c7f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/role/index.vue"
export default component.exports